export const AIBOXAPPID = '368bd23d13ffc2101926654c04871210';

export const ICON_PATH = 'https://stc.yxt.com/ufd/3f5568/yxtbiz/pc/svg';

export const SOURCE = 501;
